import { renderJSON } from '../../utils';
import { getUPReport } from '../../api-calls';

/**
 * Get data from UPRR and display table.
 *
 * @param {object} row - Record corresponding to the clicked row.
 */
export function getShipmentReportUPRR(row) {
  const closeReport = $('#closeShipmentReport');
  const header = $('#headerUPRR');
  const spinner = $('#uprrReportSpinner');
  const tableUPRR = $('#tableUPRR');

  getUPReport(row.id).then((data) => {
      header.addClass('d-flex');
      spinner.attr('hidden', true);
      closeReport.prop('disabled', false);

      // Display UPRR API data
      tableUPRR.html('');
      tableUPRR.append(renderJSON(data[0]));
      tableUPRR.prop('hidden', false);
  }).catch(error => {
    spinner.attr('hidden', true);
    closeReport.prop('disabled', false);
    header.addClass('d-flex');

    if (error.status === 404) {
      $('#infoUprrText').text('Not found');
    } else {
      $('#infoUprrText').text('Error in API request');
    }
  });
}
